import { call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import axiosInstance from '../../config/axios';
import {
  generateReportSuccess,
  generateReportFailure,
  downloadReportSuccess,
  downloadReportFailure,
  fetchReportsSuccess,
  fetchReportsFailure,
} from '../reducers/reportReducer';

function* generateReport(action: any): Generator<any, void, any> {
  try {
    const { type, analysisId, employeeId } = action.payload;
    
    const endpoint = type === 'individual' 
      ? '/api/reports/generate/employee'
      : type === 'master'
      ? '/api/reports/generate/master'
      : '/api/reports/generate/legal';

    const response: AxiosResponse = yield call(axiosInstance.post, endpoint, {
      analysisId,
      employeeId,
    });

    yield put(generateReportSuccess(response.data));
  } catch (error: any) {
    yield put(generateReportFailure(error.response?.data?.message || 'Failed to generate report'));
  }
}

function* downloadReport(action: any): Generator<any, void, any> {
  try {
    const response: AxiosResponse = yield call(axiosInstance.get, `/api/reports/download/${action.payload}`);

    yield put(downloadReportSuccess(response.data));
    
    // Create and download HTML file (web only)
    if (typeof document !== 'undefined') {
      const blob = new Blob([response.data.htmlContent], { type: 'text/html' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${response.data.title}.html`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }
  } catch (error: any) {
    yield put(downloadReportFailure(error.response?.data?.message || 'Failed to download report'));
  }
}

function* fetchReports(action: any): Generator<any, void, any> {
  try {
    const response: AxiosResponse = yield call(axiosInstance.get, `/api/reports/analysis/${action.payload}`);

    yield put(fetchReportsSuccess(response.data.reports));
  } catch (error: any) {
    yield put(fetchReportsFailure(error.response?.data?.message || 'Failed to fetch reports'));
  }
}

export default function* reportSaga() {
  yield takeLatest('report/generateReportRequest', generateReport);
  yield takeLatest('report/downloadReportRequest', downloadReport);
  yield takeLatest('report/fetchReportsRequest', fetchReports);
}